import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const StyledText = styled.p`
  /* ${({ location }) =>
    location === 'left' &&
    css`
      transform: rotate(180deg);
    `};

  ${({ location }) =>
    location === 'right' &&
    css`
      transform: rotate(90deg);
    `}; */
  text-transform: capitalize;
  color: #1d1d1d;
  font-size: 15px;
  font-weight: 500;
  font-family: Avenir;
  letter-spacing: -0.05px;
  line-height: 22px;
  margin: 0;
  margin-top: calc(100% + 60px);
  writing-mode: vertical-lr;
  /* margin-left: -50%; */
`;

const StyledWrapper = styled.div`
  width: max-content;
  position: absolute;

  ${({ location }) =>
    location &&
    location === 'left' &&
    css`
      left: 20px;
    `};

  ${({ location }) =>
    location &&
    location === 'right' &&
    css`
      right: 0;
    `};

  @media (max-width: 769px) {
    display: none;
  }
`;

const StyledLineDiv = styled.div`
  position: absolute;
  width: 1px;
  display: flex;
  flex-direction: column;
  height: 50px;

  ${({ location }) =>
    location === 'left' &&
    css`
      left: 10px;
    `};

  ${({ location }) =>
    location === 'right' &&
    css`
      right: 10px;
    `};
`;

const StyledYellowLine = styled.div`
  border: 1.5px solid #febb39;
  height: 30%;
`;

const StyledSocial = styled.div`
  margin-top: calc(100% + 60px);
`;

const StyledGreyLine = styled.div`
  background-color: #e2dfe2;
  flex-grow: 1;
  border: 1.5px solid #e2dfe2;
`;

const StickyTagComponent = ({ text, location, children }) => (
  <StyledWrapper location={location}>
    <StyledLineDiv location={location}>
      <StyledYellowLine />
      <StyledGreyLine />
    </StyledLineDiv>
    {text && <StyledText location={location}>{text}</StyledText>}
    <StyledSocial>{children && children}</StyledSocial>
  </StyledWrapper>
);

const StickyTag = memo(StickyTagComponent);

StickyTag.defaultProps = {
  text: '',
  location: 'left'
};

StickyTag.propTypes = {
  location: PropTypes.oneOf[('left', 'right')],
  text: PropTypes.string
};

export { StickyTag };
